<div class="audit-dates">
	<div class="audit-date">
		<pre-audit-checkbox [standardName]="product.standard.name" [form]="form" [pricing]="product.pricing"
							[correlationId]="order.orderCorrelationId" [clientLogged]="clientLogged" [clientCountry]="order.clientCountry"
							[preAudit]="product.additionalQuestions.initialCertificationQuestions.preAuditRequested"></pre-audit-checkbox>
	</div>

	<div class="audit-date pre-audit-date">
		<div class="audit-date-label-flex">
			<label class="date-label float-left">{{ 'additional-questions.audit-dates.pre-audit-date' | translate }}</label>
			@if (DEVICE_TYPE == 'IE') {
				<span class="float-right optional-ie-label">{{ 'common.optional' | translate }}, {{ 'additional-questions.audit-dates.date-example' | translate }}</span>
			}
			@if (DEVICE_TYPE != 'IE') {
				<span class="float-right optional-label">{{ 'common.optional' | translate }}</span>
			}
		</div>

		<date-picker [id]="'target-pre-audit-date'" [controlName]="'preAuditDate' + product.standard.name" [formGroup]="form"
					 [value]="this.product.additionalQuestions.initialCertificationQuestions.desiredPreAuditDate"
					 (onDateChangeInDefault)="updateDateFormControlAndValidateAllDates('preAuditDate', $event)"
					 [invalidDate]="isInvalid('preAuditDate')">
		</date-picker>
		<div class="validation-message">{{ getErrorsIfInvalid('preAuditDate') | async }}</div>
	</div>

	<div class="audit-date stage-1-date">
		<div class="audit-date-label-flex">
			<label [display-in-one-line]="'ETAPA 1'" class="date-label float-left">{{ 'additional-questions.audit-dates.stage-1-date' | translate }}</label>
			@if (DEVICE_TYPE == 'IE') {
				<span class="float-right optional-ie-label">{{ 'common.optional' | translate }}, {{ 'additional-questions.audit-dates.date-example' | translate }}</span>
			}
			@if (DEVICE_TYPE != 'IE') {
				<span class="float-right optional-label">{{ 'common.optional' | translate }}</span>
			}
		</div>
		<div>
			<date-picker [id]="'target-stage1-audit-date'" [controlName]="'stage1AuditDate' + product.standard.name" [formGroup]="form"
						 [value]="desiredStage1AuditDate"
						 (onDateChangeInDefault)="updateDateFormControlAndValidateAllDates('stage1AuditDate', $event)"
						 [invalidDate]="isInvalid('stage1AuditDate')">
			</date-picker>
			<div class="validation-message">{{ getErrorsIfInvalid('stage1AuditDate') | async }}</div>
		</div>
	</div>

	<div class="audit-date stage-2-date">
		<div class="audit-date-label-flex">
			<label [display-in-one-line]="'ETAPA 2'" class="date-label float-left">{{ 'additional-questions.audit-dates.stage-2-date' | translate }}</label>
			@if (DEVICE_TYPE == 'IE') {
				<span class="float-right optional-ie-label">{{ 'common.optional' | translate }}, {{ 'additional-questions.audit-dates.date-example' | translate }}</span>
			}
			@if (DEVICE_TYPE != 'IE') {
				<span class="float-right optional-label">{{ 'common.optional' | translate }}</span>
			}
		</div>
		<div>
			<date-picker [id]="'target-stage2-audit-date'" [controlName]="'stage2AuditDate' + product.standard.name" [formGroup]="form" [value]="desiredStage2AuditDate"
						 (onDateChangeInDefault)="updateDateFormControlAndValidateAllDates('stage2AuditDate', $event)"
						 [invalidDate]="isInvalid('stage2AuditDate')">
			</date-picker>
			<div class="validation-message">{{ getErrorsIfInvalid('stage2AuditDate') | async }}</div>
		</div>
	</div>

</div>
